<!-- <div id="controls">
    <button id="recordButton" (click)="startRecording()">Record</button>
    <button id="stopButton" (click)="stopRecording()">Stop</button>
</div> -->
<!-- <div id="formats">Format: start recording to see sample rate</div>
<p><strong>Recordings:</strong></p> -->
<div id="recordingsList"></div>